import { type ReactNode } from "react";
import { Button } from "@design-system/Button/Button";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { HStack } from "@design-system/HStack/HStack";
import { StandardModalHeader } from "@design-system/Modal/Modal";
import { VStack } from "@design-system/VStack/VStack";
import { ScheduleType } from "@common/types/domains/accounting/schedule";
import { ApplySourceType } from "./scheduleApplyFormHelpers";
import {
    ApplySourceDestination,
    ScheduleApplySourcePicker,
} from "./ScheduleApplySourcePicker";
import styles from "./ScheduleApplyModal.module.scss";

type ScheduleApplyPlainContentProps =
    | {
          step: "source";
          scheduleType: ScheduleType | null;
          onSelectSource: (sourceType: ApplySourceType) => void;
          onNavigate: (destination: ApplySourceDestination) => void;
          onCancel: () => void;
      }
    | {
          step: "fields";
          fields: ReactNode;
          onBack: () => void;
          isSubmitDisabled: boolean;
          isSubmitting: boolean;
          onSubmit: () => void;
      };

/** The apply modal's source picker and invoice steps. */
export const ScheduleApplyPlainContent = (
    props: ScheduleApplyPlainContentProps,
) => (
    <>
        <StandardModalHeader>Apply schedule</StandardModalHeader>
        <VStack gap={16}>
            {props.step === "source" ? (
                <VStack gap={16}>
                    <p className={styles.helperText}>
                        Choose a source to start the schedule
                    </p>
                    <ScheduleApplySourcePicker
                        scheduleType={props.scheduleType}
                        onSelect={props.onSelectSource}
                        onNavigate={props.onNavigate}
                    />
                </VStack>
            ) : (
                props.fields
            )}
            <HStack as="footer" gap={8} justify="end">
                <Button
                    type="button"
                    variant="secondary"
                    size="md"
                    onClick={
                        props.step === "source" ? props.onCancel : props.onBack
                    }
                >
                    Back
                </Button>
                {props.step === "fields" && (
                    <ButtonWithLoader
                        variant="secondary"
                        size="md"
                        loading={props.isSubmitting}
                        disabled={props.isSubmitDisabled}
                        onClick={props.onSubmit}
                    >
                        Apply schedule
                    </ButtonWithLoader>
                )}
            </HStack>
        </VStack>
    </>
);
